
















































import { mapMutations } from 'vuex'
import CookieDescription from './CookieDescription.vue'

export default {
  components: {
    CookieDescription
  },
  props: {
    cookieGroup: { type: Object, required: true },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      cookieDescriptionsVisible: false
    }
  },
  computed: {
    toggleLinkText() {
      return this.cookieDescriptionsVisible
        ? this.$t('cookieSettings.hideDetails')
        : this.$t('cookieSettings.learnMore')
    }
  },
  methods: {
    ...mapMutations(['setCookieSelection']),
    toggleCookiesInfo() {
      this.cookieDescriptionsVisible = !this.cookieDescriptionsVisible
    },
    toggleCookieSelection({ value }) {
      this.setCookieSelection({ key: this.cookieGroup.groupKey, selected: value })
    }
  }
}
